// Ecom Seekho product catalog — sourced from supplier (Rajkot Wholesale)
// Selling price auto-computed from purchase price using tier formula:
//   1–23 pcs (base): purchase × 1.15  (+15%)
//   24–48 pcs (t1):  purchase × 1.12  (+12%)
//   49+ pcs (t2):    purchase × 1.10  (+10%)

export const CATEGORIES = [
  { id: 'basket', name: 'Basket', slug: 'basket' },
  { id: 'bathroom', name: 'Bathroom Accessories', slug: 'bathroom-accessories' },
  { id: 'bottle-openers', name: 'Bottle Openers', slug: 'bottle-openers' },
  { id: 'bowls', name: 'Bowls', slug: 'bowls' },
  { id: 'bucket-mop', name: 'Bucket Mop', slug: 'bucket-mop' },
  { id: 'candle', name: 'Candle', slug: 'candle' },
  { id: 'chair', name: 'Chair and Tools', slug: 'chair-tools' },
  { id: 'chilly-cutter', name: 'Chilly Cutter', slug: 'chilly-cutter' },
  { id: 'chopper', name: 'Chopper', slug: 'chopper' },
  { id: 'water-bottle', name: 'Water Bottle', slug: 'water-bottle' },
  { id: 'water-jug', name: 'Water Jug', slug: 'water-jug' },
  { id: 'whisker', name: 'Whisker', slug: 'whisker' },
  { id: 'wiper', name: 'Wiper', slug: 'wiper' },
  { id: 'wooden', name: 'Wooden Product', slug: 'wooden' },
  { id: 'kitchen-tools', name: 'Kitchen Tools', slug: 'kitchen-tools' },
  { id: 'cutlery', name: 'Cutlery', slug: 'cutlery' },
  { id: 'car-accessories', name: 'Car Accessories', slug: 'car-accessories' },
  { id: 'key-stand', name: 'Key Stand', slug: 'key-stand' },
  { id: 'container', name: 'Container', slug: 'container' },
  { id: 'tray', name: 'Tray', slug: 'tray' },
  { id: 'lunch-box', name: 'Lunch Box', slug: 'lunch-box' },
  { id: 'toys', name: 'Toys', slug: 'toys' },
  { id: 'glass', name: 'Glass Set', slug: 'glass' },
];

// Category fallback images (used until admin uploads real images per product)
const IMG = {
  basket: 'https://images.pexels.com/photos/10079399/pexels-photo-10079399.jpeg',
  bathroom: 'https://images.unsplash.com/photo-1576729388723-8699e1a2bb23',
  'bottle-openers': 'https://images.pexels.com/photos/31699476/pexels-photo-31699476.jpeg',
  bowls: 'https://images.pexels.com/photos/5719913/pexels-photo-5719913.jpeg',
  'bucket-mop': 'https://images.unsplash.com/photo-1493953659556-556b14bdaca8',
  candle: 'https://images.unsplash.com/photo-1576729388723-8699e1a2bb23',
  chair: 'https://images.pexels.com/photos/13969208/pexels-photo-13969208.jpeg',
  'chilly-cutter': 'https://images.pexels.com/photos/37261919/pexels-photo-37261919.jpeg',
  chopper: 'https://images.pexels.com/photos/37261919/pexels-photo-37261919.jpeg',
  'water-bottle': 'https://images.pexels.com/photos/3737800/pexels-photo-3737800.jpeg',
  'water-jug': 'https://images.unsplash.com/photo-1569420077790-afb136b3bb8c',
  whisker: 'https://images.pexels.com/photos/6856215/pexels-photo-6856215.jpeg',
  wiper: 'https://images.pexels.com/photos/7108400/pexels-photo-7108400.jpeg',
  wooden: 'https://images.pexels.com/photos/13969210/pexels-photo-13969210.jpeg',
  'kitchen-tools': 'https://images.pexels.com/photos/37261919/pexels-photo-37261919.jpeg',
  cutlery: 'https://images.pexels.com/photos/5719913/pexels-photo-5719913.jpeg',
  'car-accessories': 'https://images.pexels.com/photos/13969208/pexels-photo-13969208.jpeg',
  'key-stand': 'https://images.pexels.com/photos/13969210/pexels-photo-13969210.jpeg',
  container: 'https://images.unsplash.com/photo-1576729388723-8699e1a2bb23',
  tray: 'https://images.pexels.com/photos/5719913/pexels-photo-5719913.jpeg',
  'lunch-box': 'https://images.unsplash.com/photo-1576729388723-8699e1a2bb23',
  toys: 'https://images.pexels.com/photos/13969208/pexels-photo-13969208.jpeg',
  glass: 'https://images.pexels.com/photos/3737800/pexels-photo-3737800.jpeg',
};

const r2 = (n) => Math.round(n * 100) / 100;
let _uid = 1;
// mk(name, category, purchasePrice, mrp, stock, sku, imageOverride)
const mk = (name, category, purchase, mrp, stock, sku, imgOverride) => {
  const price = r2(purchase * 1.15);
  return {
    id: 'p' + _uid++,
    sku: sku || 'M' + String(_uid).padStart(5, '0'),
    name,
    category,
    purchase_price: purchase,
    mrp: mrp || r2(price * 1.5),
    price,
    gst: 18,
    tier1: { qty: 24, price: r2(purchase * 1.12) },
    tier2: { qty: 49, price: r2(purchase * 1.10) },
    stock,
    image: imgOverride || IMG[category] || IMG.basket,
    description: `${name} — premium wholesale quality. Ideal for retailers, resellers & bulk buyers.`,
  };
};

export const PRODUCTS = [
  // ----- Basket -----
  mk('Storage Basket With Handle', 'basket', 51.20, 99, 124, 'M00155', 'https://rajkotwholesale.in/wp-content/uploads/2025/08/WhatsApp-Image-2022-08-10-at-11.16.34-AM-247x296.jpeg'),
  mk('Basket 3 Pcs Set', 'basket', 139.52, 403.64, 30, 'M00721', 'https://rajkotwholesale.in/wp-content/uploads/2025/08/BASKET-3-PCS-SET-00721-1-247x296.jpeg'),
  mk('2-Tier Fruit & Vegetable Basket (Black)', 'basket', 176.64, 507, 25, 'M02115', 'https://rajkotwholesale.in/wp-content/uploads/2025/11/download-1-247x296.webp'),
  mk('Basket 3 Pcs Set (J.K)', 'basket', 125.44, 299, 22, 'M01634'),
  mk('Basket Organizer 3 Layer', 'basket', 326.40, 999, 6, 'M01546'),
  mk('Foldable Laundry Basket with Wheels', 'basket', 422.40, 1239, 3, 'M02116'),

  // ----- Bathroom Accessories -----
  mk('Kitchen Sink Corner', 'bathroom', 21.76, 199, 154, 'M02082'),
  mk('Bathing Mug Square 1500ml (12pcs Set)', 'bathroom', 176.64, 450, 81, 'M02154'),
  mk('Bathroom Holder', 'bathroom', 89.60, 199, 64, 'M00198'),
  mk('Bathing Mug Square 1500ml (Copy)', 'bathroom', 160.05, 450, 60, 'M02154-1'),
  mk('Bathing Mug Lion 1000ml (12 Pcs)', 'bathroom', 107.52, 199, 12, 'M02090'),
  mk('Soap Stand Plastic With Cover (12 Pcs)', 'bathroom', 92.16, 150, 4, 'M01387'),
  mk('Soap Dispenser AQUA 3 In 1', 'bathroom', 76.80, 230.40, 1, 'M02338', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02338-247x296.webp'),
  mk('Soap Dish Capsule Style Leakproof', 'bathroom', 20.48, 61.44, 1, 'M02332', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02332-247x296.webp'),
  mk('Soap Box Leakproof Portable Travel', 'bathroom', 26.88, 80.64, 1, 'M02330', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02330-247x296.webp'),

  // ----- Bottle Openers -----
  mk('Bottle Motivational 3 Pcs Set Transparent', 'bottle-openers', 163.84, 517.50, 1057, 'M02270'),
  mk('Bottle Sipper KAWAI', 'bottle-openers', 83.20, 263.25, 596, 'M02236'),
  mk('Bottle Tumbler Toony 1800ml', 'bottle-openers', 83.20, 324, 417, 'M02238'),
  mk('Elaneer Opener Premium Quality', 'bottle-openers', 40.63, 199, 48, 'M00505'),

  // ----- Bowls -----
  mk('Rise Bowl', 'bowls', 30.72, 199, 546, 'M00595'),
  mk('Mug Premium 300ml', 'bowls', 55.04, 199, 429, 'M01980'),
  mk('Maggie Bowl 650ml [A]', 'bowls', 76.80, 214.94, 420, 'M00845'),
  mk('Coffee Mug Uniq', 'bowls', 58.88, 99, 354, 'M01420'),
  mk('Bowl Soup 6 Pcs Set', 'bowls', 43.52, 157.02, 289, 'M00722'),
  mk('Bottle Baby Sip Mug', 'bowls', 48.64, 150, 130, 'M01349'),
  mk('Apple Shape Serving Bowl Set 2 Pcs', 'bowls', 70.40, 499, 127, 'M00370'),
  mk('Bowl Rice Luz', 'bowls', 19.40, 49, 12, 'M01356'),
  mk('Mug Tea Cup Double Wall Color Finish', 'bowls', 69.00, 282.19, 3, 'M00840'),
  mk('Maggie Bowl 650ml (F)', 'bowls', 79.00, 399, 1, 'M00124'),
  mk('Tea Cup Classic 6 Pcs Set (Lezza)', 'bowls', 96.00, 199, 1, 'M01456'),

  // ----- Bucket Mop -----
  mk('Wiper Multicolor', 'bucket-mop', 14.72, 49, 391, 'M00744'),
  mk('6 Inch Clip Mop Yarn', 'bucket-mop', 44.80, 199, 138, 'M00388'),
  mk('Mop Road Set', 'bucket-mop', 115.20, 199, 123, 'M01412'),
  mk('Wiper Mop Without Road (16 Inch)', 'bucket-mop', 26.88, 199, 104, 'M00385'),
  mk('Bottle Mop Yarn', 'bucket-mop', 40.96, 199, 90, 'M00389'),
  mk('Mop S.S. Jali With Well (Prakash)', 'bucket-mop', 563.20, 899, 57, 'M01401'),
  mk('Kotak Mop Yarn', 'bucket-mop', 40.96, 199, 25, 'M00390'),
  mk('Mop Plastic Jali With Well (Prakash)', 'bucket-mop', 512.00, 799, 23, 'M01400'),
  mk('9 Inch Clip Mop Yarn', 'bucket-mop', 57.60, 199, 21, 'M00387'),
  mk('Mop Plastic Jali Square', 'bucket-mop', 576.00, 1200, 13, 'M01543'),
  mk('Mop S.S. Jali Square', 'bucket-mop', 704.00, 1450, 11, 'M01542'),
  mk('Mop Plastic Jali', 'bucket-mop', 379.00, 999, 9, 'M00234'),
  mk('Mop Plastic Jali Regular (SUMO)', 'bucket-mop', 486.40, 699, 7, 'M01508'),
  mk('Mop Steel Jali Regular (SUMO)', 'bucket-mop', 550.40, 599, 3, 'M01509'),

  // ----- Candle -----
  mk('Candle Water Filter Regular', 'candle', 51.20, 999, 302, 'M00085'),

  // ----- Chair and Tools -----
  mk('Foldable Tool 18 Inch', 'chair', 247.04, 599, 70, 'M00114'),
  mk('Foldable Tool 12 Inch', 'chair', 188.16, 499, 57, 'M00113'),
  mk('Foldable Chair', 'chair', 243.20, 499, 1, 'M00112'),

  // ----- Chilly Cutter -----
  mk('Mudra Chilly Cutter Stainless Steel', 'chilly-cutter', 66.56, 199, 832, 'M00003'),
  mk('Chilly Cutter Plastic Deluxe (Polypack)', 'chilly-cutter', 31.36, 199, 729, 'M00035'),
  mk('Chilly Cutter S.S. With Lid', 'chilly-cutter', 69.12, 199, 686, 'M00006'),
  mk('Chilly Cutter Round With Lid (A)', 'chilly-cutter', 49.00, 199, 430, 'M00108'),
  mk('Chilly Cutter Plastic', 'chilly-cutter', 66.56, 199, 214, 'M01951'),
  mk('Chilly Cutter Square Plastic Premium Transparent', 'chilly-cutter', 65.92, 184.70, 199, 'M00829'),
  mk('Chilly Cutter Glamaxy', 'chilly-cutter', 60.16, 149, 108, 'M01556'),
  mk('Chilly Cutter Plastic Round With Dabbi', 'chilly-cutter', 43.52, 99, 68, 'M00601'),
  mk('Chilly Cutter Transparent', 'chilly-cutter', 49.00, 199, 2, 'M00448'),

  // ----- Chopper -----
  mk('2 In 1 Veg Cutter With Peeler (N028)', 'chopper', 21.76, 199, 2646, 'M00089'),
  mk('Quick Chopper 2 In 1 500ml [B]', 'chopper', 58.88, 199, 1005, 'M00145'),
  mk('Quick Chopper 2 In 1 900ml Light', 'chopper', 66.56, 199, 689, 'M01942'),
  mk('Quick Chopper 2 In 1 450ml Heavy [F]', 'chopper', 76.80, 300, 655, 'M00019'),
  mk('Push Chopper 650ml [F]', 'chopper', 71.68, 199, 373, 'M01165'),
  mk('Push Chopper 650ml 2 In 1 Twister [R]', 'chopper', 60.16, 499, 358, 'M00353'),
  mk('Garlic Cutter', 'chopper', 80.64, 386.94, 301, 'M00861'),
  mk('Vegetable Chopper (R012)', 'chopper', 53.76, 199, 298, 'M00320'),
  mk('Chopper Easy 700 Ml Heavy', 'chopper', 74.24, 180, 282, 'M01600'),
  mk('Push Chopper 500ml [F]', 'chopper', 72.96, 199, 274, 'M01161'),
  mk('Push Chopper Solta 1000ml', 'chopper', 96.00, 299, 264, 'M02095'),
  mk('Push Chopper Insta 2 In 1 800ml', 'chopper', 96.00, 299, 218, 'M01943'),
  mk('Bottle Teddy Bear 700ml Polypack', 'chopper', 71.68, 210, 210, 'M02299'),
  mk('Push Chopper 1100ml Heavy (R)', 'chopper', 98.09, 249, 179, 'M01603'),
  mk('Chopper Easy 1100 Ml Heavy', 'chopper', 83.20, 149, 145, 'M01601'),
  mk('Push Chopper 1100ml 2 In 1 (6 Blades)', 'chopper', 96.00, 178.92, 143, 'M00778'),
  mk('Push Chopper Rapid 2 In 1 650ml [R]', 'chopper', 62.72, 188.16, 132, 'M02294'),
  mk('Push Chopper 700ml Heavy (R)', 'chopper', 87.04, 249, 130, 'M01602'),
  mk('Push Chopper 700ml 2 In 1 (F)', 'chopper', 83.20, 499, 129, 'M00348'),
  mk('Push Chopper Rapid 2 In 1 1100ml (R)', 'chopper', 81.92, 245.76, 88, 'M02292'),
  mk('Push Chopper Cleaver 1200ml', 'chopper', 97.28, 285.00, 0, 'M02296'),
  mk('Push Chopper Cleaver 750ml', 'chopper', 83.20, 243.75, 0, 'M02297'),
  mk('Veg Cutter With Peeler (Heavy)', 'chopper', 33.28, 299.00, 0, 'M00090'),
  mk('Sweet Corn Cutter Jumbo (Blister Pack) - R007', 'chopper', 29.44, 199.00, 145, 'M02255'),
  mk('Apple Cutter Small (Blister Pack)', 'chopper', 34.56, 199.00, 88, 'M02256'),
  mk('Quick Chopper 450ml - Light (Vegetable Cutter)', 'chopper', 51.20, 199.00, 210, 'M01147'),
  mk('Quick (Handy) Chopper 2 In 1 550ml Mega', 'chopper', 65.92, 199.00, 172, 'M02093'),
  mk('Quick (Handy) Chopper 2 In 1 950ml Mega', 'chopper', 79.36, 249.00, 138, 'M02094'),
  mk('Push Chopper 1100ml 2 In 1 Twister (R)', 'chopper', 83.20, 179.00, 155, 'M00355'),

  // ----- Water Bottle -----
  mk('Bottle Motivational Sipper Jumbo 2000ml', 'water-bottle', 74.24, 250, 102, 'M01849'),
  mk('Gym Shaker Spider Bottle 500ml', 'water-bottle', 70.40, 206.25, 93, 'M02258'),
  mk('Bottle Noori 800ml', 'water-bottle', 93.44, 251.10, 80, 'M02230'),
  mk('Bottle Casual 1700ml Box Pack', 'water-bottle', 107.52, 299, 78, 'M02025'),
  mk('Bottle 6 Crystal Diamond (3 Pcs Set)', 'water-bottle', 83.20, 293, 77, 'M00560'),
  mk('Bottle Power Shaker With Spring 700ml', 'water-bottle', 62.72, 249, 72, 'M02065'),
  mk('Bottle Sporty', 'water-bottle', 48.64, 153.90, 59, 'M02228'),
  mk('Bottle PARIS 1200ml (Nek)', 'water-bottle', 104.15, 249, 47, 'M02008'),
  mk('Bottle Bella 600ml (Nek)', 'water-bottle', 67.84, 149, 44, 'M00642'),
  mk('Bottle Motivational Transparent Printed 900ml', 'water-bottle', 64.00, 214.65, 41, 'M02233'),
  mk('Bottle Bella 800ml (Nek)', 'water-bottle', 74.93, 199, 36, 'M00639'),
  mk('Bottle 3 (3 Pcs Set)', 'water-bottle', 112.64, 299, 36, 'M00557'),
  mk('Bottle Zara 600ml (Nek)', 'water-bottle', 80.64, 199, 33, 'M00636'),
  mk('Bottle Fit Fusion Shaker 700ml', 'water-bottle', 108.80, 500, 25, 'M02056'),
  mk('Bottle POP Fantastic Sipper 500ml', 'water-bottle', 75.52, 199, 21, 'M02066'),
  mk('Bottle Sport Motivational Single Color 1000ml', 'water-bottle', 85.76, 222, 16, 'M02097'),
  mk('Bottle Motivational 900ml (Hydrate Elevate)', 'water-bottle', 43.52, 127.50, 15, 'M02257'),
  mk('Bottle Nexon 1200ml Box Packing', 'water-bottle', 94.04, 299, 13, 'M02003'),
  mk('Bottle Slim Campas 700ml Loose', 'water-bottle', 56.51, 199, 11, 'M02027'),
  mk('Bottle S.S. Sipper Cap Multi Utility 900ml', 'water-bottle', 76.80, 520.89, 10, 'M01286'),
  mk('Bottle Venus', 'water-bottle', 29.44, 85.68, 7, 'M02285'),
  mk('Bottle 16 Printed (3 Pcs Set)', 'water-bottle', 143.36, 318.89, 6, 'M00818'),
  mk('Bottle Teddy 700ml', 'water-bottle', 93.44, 251.10, 6, 'M02229'),
  mk('Water Bottle 6 Pcs Set', 'water-bottle', 147.20, 599, 5, 'M01681'),
  mk('Water Bottle Fridge Set of 3 (DK-139)', 'water-bottle', 84.88, 199, 5, 'M01903'),
  mk('Bottle Colorful Motivational', 'water-bottle', 128.00, 299, 5, 'M01710'),
  mk('Bottle 1700ml Polypack (F)', 'water-bottle', 97.28, 285, 4, 'M01599'),
  mk('Water Bottle CoolCare Insulated 1500ml', 'water-bottle', 79.00, 199, 4, 'M01539'),
  mk('Bottle 1100 Ml (F)', 'water-bottle', 72.96, 299, 4, 'M01597'),
  mk('Bottle Printed 3 Pcs Set (Bhagvati)', 'water-bottle', 115.20, 299, 3, 'M01436'),
  mk('Bottle Tommy 800ml Hot & Cold', 'water-bottle', 224.00, 400, 2, 'M02062'),
  mk('Bottle Printed Classic 3 Pcs Set', 'water-bottle', 147.20, 399, 2, 'M01613'),
  mk('Bottle Motivational Gym Gallon Square 2000ml', 'water-bottle', 108.80, 326.40, 1, 'M02288'),
  mk('Bottle Lexy Sip 500', 'water-bottle', 176.64, 529.92, 1, 'M02334', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02334-247x296.webp'),
  mk('Gym Shaker Bottle 700ml', 'water-bottle', 89.60, 268.80, 1, 'M02328', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02328-247x296.webp'),
  mk('Bottle Teddy Bear 1000ml Polypack', 'water-bottle', 76.80, 230.40, 1, 'M02300'),
  mk('Bottle ZIPPI 600 Polypack', 'water-bottle', 81.28, 237.93, 1, 'M02280'),
  mk('Bottle Motivational Gym Gallon Round 2000ml', 'water-bottle', 96.00, 288, 1, 'M02287'),
  mk('Bottle Bubble Polipack', 'water-bottle', 25.60, 76.80, 1, 'M02290'),
  mk('Bottle Diamond Polipack', 'water-bottle', 28.16, 76.80, 1, 'M02291'),
  mk('Bottle Ruby Polipack', 'water-bottle', 25.60, 76.80, 1, 'M02293'),
  mk('Bottle Aqva Pre 2-Layer 750ml', 'water-bottle', 198.40, 499, 1, 'M01381'),
  mk('Water Bottle CoolCare Insulated 2000ml', 'water-bottle', 89.00, 249, 1, 'M01538'),
  mk('Bottle S.S. 750 Ml (P)', 'water-bottle', 106.24, 354, 1, 'M02018'),
  mk('Bottle Tiktok Loose', 'water-bottle', 25.86, 75, 1, 'M02140'),

  // ----- Water Jug -----
  mk('Jug Diamond 1600ml (Polypack)', 'water-jug', 64.00, 192, 1129, 'M02317'),
  mk('Water Jug Honey', 'water-jug', 64.00, 187.50, 554, 'M02269'),
  mk('Orange Jug 200ml With 6 Glass Set', 'water-jug', 145.92, 249.68, 176, 'M00611'),
  mk('Pacific Juicer Jug With 4 Glass (2000ml)', 'water-jug', 128.00, 249, 130, 'M01958'),
  mk('Water Jug Dolphin 3000ml (Nek)', 'water-jug', 168.96, 299, 118, 'M01990'),
  mk('Water Jug With Stand 5000ml (Nek)', 'water-jug', 300.47, 599, 34, 'M02007'),
  mk('Water Jug Dolphin 8000ml (Nek)', 'water-jug', 385.28, 599, 30, 'M00887'),
  mk('Water Cooler Jug 5500ml Bottle', 'water-jug', 230.40, 499, 28, 'M01746'),
  mk('Orange Jug 2000ml', 'water-jug', 75.52, 225.99, 14, 'M00781'),
  mk('Water Jug Saffron 2000ml (Box Packing)', 'water-jug', 102.40, 307.20, 1, 'M02282', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02282-247x296.webp'),

  // ----- Whisker -----
  mk('Stainless Steel Whisk Hand Mixer Blender', 'whisker', 26.88, 79, 780, 'M01859'),
  mk('Whisk Full S.S. No 3 (11 Inch 66 Gram)', 'whisker', 32.00, 99, 405, 'M01395'),
  mk('Whisk Plastic Handle No 2 (1.60 mm)', 'whisker', 30.72, 99, 380, 'M01397'),
  mk('Whisk Dough Stainless Steel', 'whisker', 26.88, 99, 252, 'M01678'),
  mk('Whisk Plastic Handle No 1 (1.60 mm)', 'whisker', 28.16, 99, 159, 'M01396'),
  mk('Whisk Plastic Handle No 3 (1.60 mm)', 'whisker', 33.28, 99, 126, 'M01398'),
  mk('Whisk Full S.S. No 2 (10 Inch 60 Gram)', 'whisker', 29.44, 99, 75, 'M01394'),
  mk('Whisk Full S.S. No 1 (9 Inch 54 Gram)', 'whisker', 26.88, 99, 20, 'M01393'),
  mk('Whisk Coile (1.4mm 50 Gram)', 'whisker', 29.44, 99, 16, 'M01399'),

  // ----- Wiper -----
  mk('Wiper Clinging (G)', 'wiper', 28.16, 99, 1041, 'M02071'),
  mk('Wiper With Spray', 'wiper', 39.68, 97.50, 385, 'M02156'),
  mk('Wiper 360 Degree Rotated', 'wiper', 46.72, 199, 323, 'M02070'),
  mk('Wiper Silicon 20 Inch 22mm With S.S. Road 4 Feet', 'wiper', 149.00, 199, 1, 'M01498'),
  mk('Wiper Silicon 12 Inch 19mm With S.S. Road 2 Feet', 'wiper', 69.00, 149, 1, 'M01496'),

  // ----- Wooden -----
  mk('Table Clock Round Small (16 x 9)', 'wooden', 83.20, 199, 10, 'M50254'),

  // ----- Kitchen Tools (from /bulk page) -----
  mk('Slicer Small Hole S.S. With Stand', 'kitchen-tools', 56.32, 199, 673, 'M01996', 'https://rajkotwholesale.in/wp-content/uploads/2025/11/1996-2-247x296.jpg'),
  mk('Jumbo Slicer Stainless Steel', 'kitchen-tools', 66.56, 199, 465, 'M00345', 'https://rajkotwholesale.in/wp-content/uploads/2025/10/00345-1-1-247x296.jpg'),
  mk('Ice Cream Scoop (G011)', 'kitchen-tools', 40.00, 199, 94, 'M000167', 'https://rajkotwholesale.in/wp-content/uploads/2025/08/RTS002-00167-247x296.jpg'),
  mk('Folding Cut And Wash', 'kitchen-tools', 109.15, 499, 45, 'M000185'),
  mk('Coconut Breaker S.S. Medium (W012)', 'kitchen-tools', 134.40, 499, 212, 'M00312'),
  mk('ABS Slicer Zari (B-172)', 'kitchen-tools', 44.80, 199, 0, 'M00302'),
  mk('ABS Slicer Plain (B-171)', 'kitchen-tools', 44.80, 199, 37, 'M00301'),
  mk('Single Blade Slicer S.S.', 'kitchen-tools', 28.16, 99, 566, 'M00343'),
  mk('Plastic Paubhaji Plate 3 In 1 (Small)', 'kitchen-tools', 38.40, 199, 18, 'M00247'),
  mk('Corn Cutter S.S.', 'kitchen-tools', 33.28, 99, 857, 'M01535'),
  mk('Cute Peeler Heavy Vegetable Peeler', 'kitchen-tools', 25.60, 99, 252, 'M00361'),
  mk('Bottle Steelwell S.S. Feeding 250ml', 'kitchen-tools', 217.60, 595.99, 156, 'M00836'),

  // ----- Cutlery -----
  mk('Cutlery Set Diamond Wire', 'cutlery', 352.00, 999, 54, 'M00551'),
  mk('Cutlery Set Diamond', 'cutlery', 352.00, 999, 21, 'M00546'),

  // ----- Car Accessories -----
  mk('Car Dashboard Decore Two Side Printed Premanandji Maharaj (4x3 inch)', 'car-accessories', 40.00, 61.44, 0, 'CD007', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/CD007-247x296.jpg'),
  mk('Car Dashboard Decore Two Side Printed Lord Buddha (4x3 inch)', 'car-accessories', 40.00, 61.44, 0, 'CD006', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/CD006-247x296.jpg'),
  mk('Car Dashboard Decore Two Side Printed Lord Hanumanji (4x3 inch)', 'car-accessories', 40.00, 61.44, 0, 'CD005', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/CD005-247x296.jpg'),
  mk('4 Cute God Car Dashboard Decore Two Side Printed', 'car-accessories', 60.00, 61.44, 0, 'CD003', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/4cute-god-247x296.jpg'),
  mk('Ujjain Baba Mahakal Mahakaleshwar Shivling Car Dashboard (4x3 inch)', 'car-accessories', 40.00, 61.44, 0, 'CD002', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/mahakal-247x296.jpg'),
  mk('Car Hanging Accessories Lord Shiva Baby Wooden (4x2.5 inch)', 'car-accessories', 30.00, 61.44, 0, 'CH001', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/shiva-hang-247x296.jpg'),

  // ----- Key Stand -----
  mk('Key Stand Krishna With Cow and Peacock Printed With Hook (6x8 inch)', 'key-stand', 55.00, 142.50, 467, 'KH004'),
  mk('Key Stand Krishna Printed With Hook (6x8 inch)', 'key-stand', 55.00, 225.00, 478, 'KH001'),

  // ----- Additional Bathroom -----
  mk('Shop Stand Plastic (Rupapra)', 'bathroom', 12.80, 34.00, 0, 'M01554'),

  // ===== NEW PRODUCTS FROM /shop CRAWL (with real image URLs) =====
  // ----- Lunch Box -----
  mk('Lunch Box Bella Bites (Box Pack)', 'lunch-box', 79.36, 238.08, 60, 'M02333', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02333-247x296.webp'),
  mk('Lunch Box Starwin (Polypack)', 'lunch-box', 76.80, 230.40, 0, 'M02310'),
  mk('Lunch Box Big Daddy', 'lunch-box', 71.68, 208.59, 45, 'M02311'),
  mk('Lunch Box School Kid', 'lunch-box', 76.80, 230.40, 30, 'M02312'),
  mk('Lunch Box Tedee', 'lunch-box', 83.20, 249.60, 25, 'M02313'),

  // ----- Glass Set -----
  mk('Glass Majik Linear 300ml (6 Pcs Set)', 'glass', 84.48, 253.44, 80, 'M02337', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02337-247x296.webp'),
  mk('Glass Majik Diamond 300ml (6 Pcs Set)', 'glass', 80.64, 241.92, 75, 'M02336', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02336-247x296.webp'),

  // ----- Toys -----
  mk('Toy Spinning Tops 10 Pcs Set', 'toys', 71.68, 215.04, 50, 'M02331', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02331-247x296.webp'),

  // ----- Container -----
  mk('Container Window 3 Pcs Set', 'container', 106.24, 318.72, 40, 'M02326', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02326-247x296.webp'),
  mk('Container Milano 2 Pcs Set (500ml)', 'container', 64.00, 192.00, 55, 'M02325', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02325-247x296.webp'),
  mk('Container Excellent 2 Pcs Set (900ml)', 'container', 76.80, 230.40, 48, 'M02323', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02323-247x296.webp'),
  mk('Container Orion 2 Pcs Set (1000ml)', 'container', 80.64, 241.92, 42, 'M02322', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02322-247x296.webp'),
  mk('Container Dolphin 1100ml (2 Pcs Set)', 'container', 80.64, 241.92, 38, 'M02314'),
  mk('Container Feel Fresh 900ml (Polypack)', 'container', 69.12, 207.36, 35, 'M02315'),
  mk('Dry Fruit Box Multipurpose Zest', 'container', 64.00, 192.00, 40, 'M02316'),

  // ----- Tray -----
  mk('Tray Ringo Round 3 Pcs Set (Polypack)', 'tray', 76.80, 230.40, 32, 'M02317'),
  mk('Tray Classic Big', 'tray', 64.00, 192.00, 28, 'M02318'),
  mk('Tray Serving Clear Transparent 200gm (F)', 'tray', 57.60, 172.80, 40, 'M02319'),

  // ----- Kitchen Tools (extra) -----
  mk('Peeler S.S. Grip (Y Shape 1-Dozen)', 'kitchen-tools', 71.68, 215.04, 65, 'M02335', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02335-247x296.webp'),
  mk('Peeler Premium (Virgin) 1 Dozen (Blister Pack)', 'kitchen-tools', 72.96, 218.88, 0, 'M02308'),
  mk('Tea Strainer S.S. No.4 (1-Dozen)', 'kitchen-tools', 35.72, 1286.40, 300, 'M02327', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02327-247x296.webp'),

  // ----- Water Jug (extra) -----
  mk('Water Jug Cool World Insulated 6000ml (Box Pack)', 'water-jug', 172.80, 518.40, 0, 'M02320'),

  // ----- Water Bottle (extra) -----
  mk('Bottle S.S. 1000ml (Cool Ton Slim)', 'water-bottle', 116.48, 351.00, 22, 'M02321'),
  mk('Bottle Rocket Kawai 900ml (Polypack)', 'water-bottle', 76.80, 230.40, 30, 'M02339'),
  mk('Bottle Teddy Bear 1000ml Polypack', 'water-bottle', 76.80, 230.40, 28, 'M02340'),
  mk('Bottle Insulated Alexa 800 Box Pack', 'water-bottle', 124.80, 365.31, 18, 'M02341'),
  mk('Bottle Square With Plastic Cap (Polipack)', 'water-bottle', 29.44, 85.68, 50, 'M02342'),

  // ----- Key Stand (extra) -----
  mk('Key Stand Rustic Royal', 'key-stand', 70.40, 211.20, 35, 'M02329', 'https://rajkotwholesale.in/wp-content/uploads/2026/07/M02329-247x296.webp'),
  mk('Black Home Key Holder 6x8 inch (KH053)', 'key-stand', 59.00, 500.00, 42, 'KH053'),
];

export const HERO_BANNERS = [
  {
    id: 'b1',
    title: 'Sabse Sasta, Sabse Achha',
    subtitle: 'Wholesale rates for retailers, resellers & bulk buyers',
    cta: 'Shop Now',
    link: '/shop',
    bg: 'linear-gradient(135deg, #e8f5e9 0%, #fff3e0 100%)',
  },
  {
    id: 'b2',
    title: 'Kitchen Essentials',
    subtitle: 'Choppers, Bottles, Bowls & more at factory prices',
    cta: 'Explore',
    link: '/shop?category=chopper',
    bg: 'linear-gradient(135deg, #fff3e0 0%, #e8f5e9 100%)',
  },
];

export const MOCK_ORDERS = [];

export const ADMIN_CREDS = { username: 'EcomSeekho56', password: 'Ecom@567' };
